import React from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import intl from 'react-intl-universal';
import Button from 'components/Button/Button';
import { hooks } from '@lifesize/clients.sdk';

interface Props {
  handleJoinMeeting: () => void;
  hasError: boolean;
  isCalling: boolean;
  isDisabled: boolean;
  extension: string;
}

const JoinButton = ({
  handleJoinMeeting,
  isCalling,
  isDisabled,
  extension
}: Props): React.ComponentElement<Props, any> => {
  const { localPrimaryStream } = hooks.useMedia();
  const classes = useStyles();

  return (
    <Box mt={1} mb={2} width={'100%'}>
      <Button
        className={classes.formField}
        kind="primary"
        dataAttrs={{
          'data-testid': 'join'
        }}
        disabled={isDisabled && localPrimaryStream}
        onClick={handleJoinMeeting}
      >
        <Typography variant="button">
          {isCalling ? `${intl.get('begin')} ${extension}` : intl.get('joinMeeting')}
        </Typography>
      </Button>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  formField: {
    borderRadius: 0
  }
}));

export default JoinButton;
